class Fad {
    constructor() {
        this.fadEl = document.getElementById('fad-map-full') || document.getElementById('fad-map-locator') || document.getElementById('fad-widget');
        this.fadWidget = !!document.getElementById('fad-widget');
        if (!this.fadEl) return;

        this.referenceCoordinates = {
            latitude: 49.8175,
            longitude: 15.4730,
        }

        this.countryCzechName = "Česko";

        this.filters = {
            only_private_patient: null,
            is_doctor: null,
            is_allergy_diagnostic: null,
            is_insect_allergy_diagnostic: null,
            is_sublingual_immunotherapy : null,
            is_subcutaneous_immunotherapy: null,
            is_venom_immunotherapy: null,
            clinic_types: null,
            specialist_areas: null,
            other_services: null,
            insurance_companies: null,
            telehealth: null,
            miles: null
        };

        this.fadPrefix = 'vyhledat-alergologa';
        this.fadIframePrefix = 'fad-iframe';
        // this.campaignPrefix = 'verpasse-nicht-den-fruehling';
        this.clinicPagePrefix = 'lekare';
        this.url = window.location.href;
        this.cityHandle = new URL(this.url).pathname.split(`/${this.fadPrefix}/`);
        this.cityHandle = this.cityHandle.length > 1 ? (this.cityHandle[this.cityHandle.length - 1] || '') : '';
        this.isCityPage = !!this.cityHandle;

        this.fadIframe = new URL(this.url).pathname;
        this.fadIframe = this.fadIframe && (this.fadIframe.includes('iframe') || this.fadIframe.includes(this.fadIframePrefix));

        this.queryParams = {};

        this.searchEl = document.getElementById('fad-search');
        this.clinicResultEl = document.getElementById('fad-map-list');
        this.noResultEl = document.getElementById('no-result-text');
        this.loaderEl = document.getElementById('map-loader');

        this.searchValue = this.isCityPage ? this.searchEl.getAttribute('data-search') : '';

        this.map = null;
        this.searchBbox = [];
        this.clinics = [];
        this.clinic = null;
        this.markers = [];
        this.zoom = 0;
        this.marker = null;
        this.userLocation = {
            lat: window.defaultUserLocation.lat,
            lng: window.defaultUserLocation.lng
        };
        this.cityLocation = null;
        this.apiParams = {
            lat: null,
            lng: null,
            radius: window.defaultSearchRadius,
            city: this.cityHandle,
        };
        this.firstLoad = true;
        this.filtersApplied = false;
        this.isMobile = window.innerWidth < 768;
        this.isTablet = window.innerWidth >= 768 && window.innerWidth < 1200;

        this.widgetIntialized = false;
        this.preInitialization();
    }

    async preInitialization() {
        if(!this.fadWidget) {
            await this.init();
        }
        else {
            let fadWidgetEl = document.getElementById('fad-widget');
            let widgetIntoView = this.isElementIntoView(fadWidgetEl);
            if (!widgetIntoView) {
                document.addEventListener('scroll', async (event) => {
                    if (!this.widgetIntialized) {
                        let fadWidgetEl = document.getElementById('fad-widget');
                        widgetIntoView = this.isElementIntoView(fadWidgetEl);
                        if (widgetIntoView) {
                            this.widgetIntialized = true;
                            await this.init();
                        }
                    }
                });
            } else {
                this.widgetIntialized = true;
                await this.init();
            }
        }
    }

    async init() {

        if(!this.fadWidget) this.manageMapSwitchButton();
        this.setQueryParams();
        await this.setLocation();
        await this.processMap();
        if(!this.fadWidget) await this.buildFilter();
        await this.bindEvents();
    }

    manageMapSwitchButton() {
        document.addEventListener('scroll', () => {
            if (this.isMobile) {
                let mapBlock = document.querySelector('#map-block');
                if (!mapBlock) return;

                let fadMapScroll = mapBlock.getBoundingClientRect().bottom;

                let fadListScroll = document.querySelector('#fad-list-primary-block');
                if (fadListScroll) fadListScroll = fadListScroll.getBoundingClientRect().bottom;

                let listChangeBtn = document.querySelector('#list-change-btn-wrapper');

                let checkView = listChangeBtn.querySelector('#list-change-btn span.d-none').getAttribute('data-view');

                if ((checkView === 'map' ? fadMapScroll : fadListScroll) < (window.innerHeight - listChangeBtn.clientHeight)) {
                    listChangeBtn.classList.remove('btn-sticky');
                } else {
                    listChangeBtn.classList.add('btn-sticky');
                }
            }
        });
    }

    setQueryParams() {
        const url = new URL(this.url);
        let queryParams = url.searchParams;
        queryParams.forEach((value, name) => {
            this.queryParams[name] = value ? value : '';
        });

        if (this.queryParams.zoom) {
            let zoom = parseFloat(this.queryParams.zoom);
            if (zoom) this.zoom = parseFloat(this.queryParams.zoom);
        }
        this.searchValue = this.queryParams.address;

        for(const [name, value] of Object.entries(this.filters)) {
            if (this.queryParams.hasOwnProperty(name) && this.queryParams[name]) {
                this.filters[name] = this.queryParams[name];
            }
        }
    }

    async setUserLocation() {
        // Take value from URL or cookie or current location

        let validCoordinates = this.validateCoordinates(this.queryParams.latitude, this.queryParams.longitude);
        if (this.queryParams.address && this.queryParams.latitude && this.queryParams.longitude && validCoordinates) {

            this.userLocation = {
                lat: this.queryParams.latitude,
                lng: this.queryParams.longitude,
            };
            this.searchValue = this.queryParams.address;
        }
        else {
            let userLocationLat = null;
            let userLocationLng = null;
            let userLocationCity = null;
            let userLocationCountry = null;

            let pollenHeaderValue = null;
            if(this.getCookie('pollenHeaderValue') != '' && this.getCookie('pollenHeaderValue') != null && this.getCookie('pollenHeaderValue') != 'pollenHeaderValue') {
                pollenHeaderValue = decodeURI(this.getCookie('pollenHeaderValue'));
            }
            else {
                pollenHeaderValue = decodeURI(localStorage.getItem('pollenHeaderValue'));
            }

            try {
                if(this.getCookie('userLocationLat') != '' && this.getCookie('userLocationLat') != null && this.getCookie('userLocationLat') != 'userLocationLat') {
                    userLocationLat = this.getCookie('userLocationLat');
                    userLocationLng = this.getCookie('userLocationLng');
                    userLocationCity = decodeURI(this.getCookie('userLocationCity'));
                    userLocationCountry = decodeURI(this.getCookie('userLocationCountry')); 
                }
                else{
                    userLocationLat = localStorage.getItem('userLocationLat');
                    userLocationLng = localStorage.getItem('userLocationLng');
                    userLocationCity = localStorage.getItem('userLocationCity');
                    userLocationCountry = localStorage.getItem('userLocationCountry');
                }
            } catch (e) {
                console.error(e);
            }

             if(pollenHeaderValue && pollenHeaderValue != null && pollenHeaderValue != 'null' && userLocationLat && userLocationLng && userLocationCity && userLocationCountry) {

                this.userLocation = {
                    lat: parseFloat(userLocationLat),
                    lng: parseFloat(userLocationLng),
                }
                this.searchValue = pollenHeaderValue;
                   
            } else {
                if (userLocationLat && userLocationLng && userLocationCity && userLocationCountry) {

                    this.userLocation = {
                        lat: parseFloat(userLocationLat),
                        lng: parseFloat(userLocationLng),
                    };

                    this.searchValue = `${userLocationCity}, ${this.countryCzechName}`;

                }
                else {

                    try {
                        let response = await fetch(`https://api.ipstack.com/check?access_key=771c7cd15b294eb19b2e29264ff2b8c2`);
                        response = await response.json();


                        if (response.country_name !== window.countryName) {

                            response.latitude = window.defaultUserLocation.lat;
                            response.longitude = window.defaultUserLocation.lng;
                            response.city = window.defaultCity;
                            response.country_name = window.countryName;
                        }

                        this.userLocation = {
                            lat: response.latitude,
                            lng: response.longitude,
                        };

                        this.searchValue = `${response.city}, ${this.countryCzechName}`;

                        let formattedCoordinates = this.formatCoordinates(response.latitude, response.longitude);

                        this.setCookie('userLocationLat', formattedCoordinates.latitude, 30);
                        this.setCookie('userLocationLng', formattedCoordinates.longitude, 30);
                        this.setCookie('userLocationCity', response.city, 30);
                        this.setCookie('userLocationCountry', response.country_name, 30);

                    } catch (e) {
                        this.userLocation = {
                            lat: window.defaultUserLocation.lat,
                            lng: window.defaultUserLocation.lng,
                        };

                        this.searchValue = `${window.defaultCity}, ${window.countryName}`;

                        console.error('IP stack API failed', e);
                    }
                }
            }
        }

        if (this.searchValue) {
            document.getElementById('fad-search').setAttribute('data-search', this.searchValue);
        }
    }

    async setCityLocation() {
        let searchEl = document.getElementById('fad-search');
        this.searchValue = searchEl.getAttribute('data-search');
        if (!this.searchValue) {
            this.searchValue = searchEl.getAttribute('value');
        }

        let city = this.searchValue.split(',');
        city = city[0] || null;
        city = city.trim();
        if (!city) return;

        try {
            let response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${city}.json?access_token=${window.mapBoxAPIKey}`);
            response = await response.json();

            this.userLocation = {
                lng: response.features[0].center[0],
                lat: response.features[0].center[1],
            };
        } catch (e) {
            console.error('City places API call failed', e);
        }
    }

    async setQueryParamLocation() {
      let city = this.queryParams.address.split(',');
      city = city[0] || null;
      city = city.trim();
      if (!city) return;

      try {
          let response = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${city}.json?access_token=${window.mapBoxAPIKey}`);
          response = await response.json();
          
          if (response.features.length > 0 && response.features[0].place_type.includes("place")) {
            this.userLocation = {
                lng: response.features[0].center[0],
                lat: response.features[0].center[1],
            };
          }
          else {
            await this.setUserLocation();
          }
      } catch (e) {
          console.error('City places API call failed', e);
        await this.setUserLocation();
      }
    }

    async setLocation() {
      let validCoordinates = this.validateCoordinates(this.queryParams.latitude, this.queryParams.longitude);
      if (this.isCityPage) {
        await this.setCityLocation();
      }
      else if (this.queryParams.address && !validCoordinates) {
         await this.setQueryParamLocation();              
      } 
      else { 
        await this.setUserLocation();
      }
    }

    async updateRecords() {

        let initialization = this.firstLoad || this.filtersApplied;
        if(!this.apiParams.lng || !this.apiParams.lat) return;
        let formattedCoordinates = this.formatCoordinates(this.apiParams.lat, this.apiParams.lng);
        this.apiParams.lat = formattedCoordinates.latitude;
        this.apiParams.lng = formattedCoordinates.longitude;

        let params = {
            country: window.countryCode,
            latitude: this.apiParams.lat,
            longitude: this.apiParams.lng,
        };

        for (const [name, value] of Object.entries(this.filters)) {

            if (value) {

                if (name === 'radius') {

                    params.radius = parseInt(value);

                } else {

                    if (['other_services', 'insurance_companies', 'clinic_types', 'specialist_areas'].includes(name)) params[name] = value;
                    else params[name] = parseInt(value);
                }
            }
        }

        if (this.apiParams.city) {
            this.queryParams.city = this.apiParams.city;
            params.city = this.apiParams.city;
        }

        this.manageURL(params);

        let loader = document.getElementById('map-loader');

        if (initialization) {
            if (loader.classList.contains('d-none')) {
                loader.classList.remove('d-none');
            }

            this.clearRecords();

            await this.loadClinics(params);
        }

        if (!this.clinics.length) {

            if (this.clinicResultEl) document.getElementById('fad-map-list').innerHTML = '';

            if (this.noResultEl) {
                document.querySelector('#no-result-text').innerText = 'Nenalezeny žádné záznamy.';
                document.getElementById('loading-text').classList.remove('d-md-block');
            }

            if (this.loaderEl) loader.classList.add('d-none');

            return;
        }

        if (this.marker && this.marker.getPopup().isOpen()) {
            this.marker.togglePopup();
        }

        // this.clinics.sort((a, b) => Math.abs(a.distance - this.apiParams.radius) - Math.abs(b.distance - this.apiParams.radius));
        // this.markers.sort((a, b) => Math.abs(a.distance - this.apiParams.radius) - Math.abs(b.distance - this.apiParams.radius));

        this.clinics.sort((a, b) => {
            let distanceA = this.calculateDistance(
                this.apiParams.lat,
                this.apiParams.lng,
                a.latitude,
                a.longitude
            );
            let distanceB = this.calculateDistance(
                this.apiParams.lat,
                this.apiParams.lng,
                b.latitude,
                b.longitude
            );
            return distanceA - distanceB;
        });

        this.markers.sort((a, b) => {
            let distanceA = this.calculateDistance(
                this.apiParams.lat,
                this.apiParams.lng,
                a.latitude,
                a.longitude
            );
            let distanceB = this.calculateDistance(
                this.apiParams.lat,
                this.apiParams.lng,
                b.latitude,
                b.longitude
            );
            return distanceA - distanceB;
        });

        if (this.noResultEl) document.querySelector('#no-result-text').innerText = '';

        this.prepareClinicListHTML(initialization);

        if (initialization) {
            if (this.loaderEl) loader.classList.add('d-none');
        }

        let highlightClinicIndex = 0;

        if (this.firstLoad) {
            this.firstLoad = false;
            if (this.queryParams.name) {
                let tempIndex = this.clinics.findIndex(item => item.doctor_name === this.queryParams.name);
                if (tempIndex !== -1) highlightClinicIndex = tempIndex;
            }
        }

        this.clinic = this.clinics[highlightClinicIndex];

        if (!this.fadWidget) {
            let name = this.clinic.doctor_name;
            let clinicEl = document.querySelector(`#fad-map-list .search-data-block[data-doctor-name ="${name}"]`);
            if (clinicEl) clinicEl.classList.add('active');
            this.markers[highlightClinicIndex].togglePopup();
        }
    }

    async loadClinics(params) {
        // For all clinics set => all = 1 and for city clinics set => city = birmingham-al
        let response = {};
        try {
            params.latitude = this.referenceCoordinates.latitude;
            params.longitude = this.referenceCoordinates.longitude;
            params.radius = 1500000;
            if (this.filtersApplied && this.filters.miles && this.filters.radius) {
                params.radius = this.filters.radius;
                params.latitude = this.apiParams.lat;
                params.longitude = this.apiParams.lng;
            }

            response = await fetch('https://alk-app.klarify.me/api/clinics?' + new URLSearchParams(params), {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${window.klarifyAppToken}`,
                    'Accept': 'application/json'
                }
            });
            response = await response.json();

        } catch (e) {
            console.error('Clinics API failed', e);
            if (this.loaderEl) loader.classList.add('d-none');
            Rollbar.error("Clinics API failed");
            return;
        }

        this.clinics = response.clinics || [];
    }

    prepareClinicListHTML(initializeMarkers = false) {
        let clinicsHTML = '';
        (this.clinics ? this.clinics : []).forEach((clinic, index) => {
            if(!this.fadWidget) {
                let phoneHTML = '';
                if (clinic.phone) {

                    phoneHTML = `
                                <li class="upper-index">
                                    <span class="sg-icon">
                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 10 10" style="enable-background:new 0 0 10 10;" xml:space="preserve">
                                            <g transform="translate(0)">
                                                <path d="M9.2,6.6C8.6,6.6,8,6.5,7.4,6.3c-0.3-0.1-0.6,0-0.8,0.2L5.5,7.3C4.3,6.7,3.3,5.7,2.7,4.5l0.8-1.1 c0.2-0.2,0.3-0.5,0.2-0.8C3.5,2,3.4,1.4,3.4,0.8C3.4,0.4,3.1,0,2.6,0H0.8C0.4,0,0,0.4,0,0.8C0,5.9,4.1,10,9.2,10 C9.6,10,10,9.6,10,9.2l0,0V7.4C10,6.9,9.6,6.6,9.2,6.6C9.2,6.6,9.2,6.6,9.2,6.6z"/>
                                            </g>
                                        </svg>
                                    </span>
                                    <a class="doc-phone text-primary" id="card-phone-${clinic.id}" href="tel:${clinic.phone}">${clinic.phone.replace('(','').replace(')','')}</a>
                                </li>
                            `;
                }

                let emailHTML = '';
                if (clinic.email) {

                    emailHTML = `
                                <li class="upper-index">
                                    <span class="sg-icon">
                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 11.5 8.6" style="enable-background:new 0 0 11.5 8.6;" xml:space="preserve">
                                            <g transform="translate(0 -64.266)">
                                                <path d="M6.7,69.8c-0.6,0.4-1.3,0.4-1.9,0l-4.7-3.1c0,0-0.1,0-0.1-0.1v5.1c0,0.6,0.5,1.1,1.1,1.1c0,0,0,0,0,0h9.3 c0.6,0,1.1-0.5,1.1-1.1c0,0,0,0,0,0v-5.1c0,0-0.1,0-0.1,0.1L6.7,69.8z"/>
                                                <path d="M0.4,66.2l4.7,3.1c0.4,0.2,0.8,0.2,1.2,0l4.7-3.1c0.3-0.2,0.5-0.5,0.4-0.8c0-0.6-0.5-1.1-1.1-1.1 c0,0,0,0,0,0H1.1c-0.6,0-1.1,0.5-1.1,1.1C0,65.7,0.2,66,0.4,66.2z"/>
                                            </g>
                                        </svg>
                                    </span>
                                    <a class="doc-email text-primary" id="card-email-${clinic.id}" href="mailto:${clinic.email}">${clinic.email}</a>
                                </li>
                            `;
                }

                let websiteHTML = '';
                if (clinic.website) {

                    websiteHTML = `
                            <li class="upper-index">
                                <span class="sg-icon">
                                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20.1 20.1" style="enable-background:new 0 0 20.1 20.1;" xml:space="preserve">
                                        <path d="M17.1,3C13.2-1,6.9-1,3,2.9S-1,13.1,2.9,17c0,0,0,0,0.1,0.1c3.9,3.9,10.2,4,14.1,0.1S21.1,6.9,17.1,3 C17.1,3,17.1,3,17.1,3z M3.8,3.8c0.9-0.9,1.9-1.5,3-2C6.5,2.2,6.2,2.6,6,3.1C5.7,3.7,5.4,4.3,5.2,4.9c-0.7-0.1-1.4-0.3-2-0.5 C3.4,4.2,3.6,4,3.8,3.8z M2.5,5.5c0.8,0.2,1.6,0.4,2.4,0.6C4.6,7.2,4.5,8.3,4.5,9.4H1.2C1.3,8,1.7,6.7,2.5,5.5z M2.4,14.5 c-0.7-1.2-1.1-2.5-1.2-3.9h3.2c0,1.1,0.2,2.2,0.4,3.3C4.1,14,3.2,14.2,2.4,14.5z M3.8,16.3c-0.2-0.2-0.5-0.5-0.7-0.8 c0.7-0.2,1.4-0.3,2.1-0.4c0.2,0.6,0.5,1.3,0.8,1.9c0.3,0.5,0.6,1,0.9,1.4C5.7,17.8,4.7,17.2,3.8,16.3L3.8,16.3z M9.4,18.7 c-1.1-0.4-2-1.3-2.4-2.4c-0.2-0.5-0.5-1-0.6-1.5c1-0.1,2-0.2,3-0.2V18.7z M9.4,13.5c-1.1,0-2.3,0.1-3.4,0.2c-0.2-1-0.4-2.1-0.4-3.1 h3.8L9.4,13.5L9.4,13.5z M9.4,9.4H5.6c0-1.1,0.2-2.2,0.4-3.2c1.1,0.1,2.2,0.2,3.4,0.2V9.4z M9.4,5.3c-1.1,0-2.1-0.1-3-0.2 c0.2-0.5,0.4-1,0.6-1.5c0.5-1.1,1.3-1.9,2.4-2.4V5.3L9.4,5.3z M17.6,5.5c0.7,1.2,1.1,2.5,1.2,3.9h-3.2c0-1.1-0.2-2.2-0.4-3.3 C16,6,16.8,5.8,17.6,5.5L17.6,5.5z M16.3,3.8c0.2,0.2,0.5,0.5,0.7,0.7c-0.7,0.2-1.4,0.3-2.1,0.4c-0.2-0.6-0.5-1.3-0.8-1.9 c-0.2-0.5-0.5-0.9-0.8-1.3C14.4,2.2,15.4,2.9,16.3,3.8z M10.6,10.6h3.8c0,1.1-0.2,2.1-0.4,3.1c-1.1-0.1-2.2-0.2-3.4-0.2L10.6,10.6z M10.6,9.4v-3c1.1,0,2.3-0.1,3.4-0.2c0.2,1,0.4,2.1,0.4,3.2L10.6,9.4L10.6,9.4z M10.6,1.3L10.6,1.3c1.1,0.4,2,1.3,2.4,2.4 c0.2,0.5,0.5,1,0.6,1.5c-1,0.1-2,0.2-3.1,0.2L10.6,1.3z M10.6,18.7v-4c1.1,0,2.1,0.1,3,0.2c-0.2,0.5-0.4,1-0.6,1.4 C12.6,17.4,11.7,18.3,10.6,18.7z M16.3,16.3c-0.9,0.9-1.9,1.6-3.1,2c0.4-0.4,0.7-0.9,0.9-1.4c0.3-0.6,0.6-1.2,0.8-1.8 c0.7,0.1,1.4,0.3,2.1,0.5C16.7,15.8,16.5,16,16.3,16.3L16.3,16.3z M17.6,14.5c-0.8-0.3-1.6-0.4-2.5-0.6c0.3-1.1,0.4-2.2,0.4-3.3h3.2 C18.7,12,18.3,13.3,17.6,14.5L17.6,14.5z"/>
                                    </svg>
                                </span>
                                <a class="website-click text-primary" id="card-website-${clinic.id}" target="_blank" href="${clinic.website}">
                                    <u>Webové stránky</u>
                                </a>
                                </li>
                            `;
                }

                let timingsHTML = '';
                if (clinic.timings.length) {

                    let daysHTML = '';
                    clinic.timings.forEach(clinicTiming => {

                        daysHTML += `<p><span class="day">${clinicTiming.translations.de}</span> `;
                        daysHTML += `<span class="time">`;
                        clinicTiming.opening_hours.forEach((openingHour, i) => {
                            if (i > 0) daysHTML += ` & `;
                            daysHTML += `${openingHour.opening_time}-${openingHour.closing_time}`;
                        });
                        daysHTML += `</span>`;
                        daysHTML += `</p>`;
                    });

                    timingsHTML = `
                        <li class="upper-index opening-hours">
                            <span class="sg-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 12 12" style="enable-background:new 0 0 12 12;" xml:space="preserve"> <path d="M6,0C2.7,0,0,2.7,0,6s2.7,6,6,6s6-2.7,6-6S9.3,0,6,0z M8,8C7.8,8.2,7.5,8.2,7.3,8c0,0,0,0,0,0L5.6,6.4 C5.5,6.3,5.5,6.1,5.5,6V2.7c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v3L8,7.3C8.2,7.5,8.2,7.8,8,8C8,8,8,8,8,8z"/> </svg></span>
                            <div class="doctor-data">
                                <h6>Öffnungszeiten</h6>
                                ${daysHTML}
                            </div>
                        </li> <hr>
                    `;
                }

                let waitingTimeHTML = '';
                if (clinic.waiting_time) {

                    waitingTimeHTML = `
                        <li class="upper-index">
                            <span class="sg-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 9.9 11.8" style="enable-background:new 0 0 9.9 11.8;" xml:space="preserve"> <path id="health-insurance" d="M5,11.8C7.3,11,8.5,10,9.2,8.3c0.7-1.7,0.8-3.9,0.7-7L5,0L0,1.2c-0.1,3.1,0,5.4,0.7,7 C1.4,10,2.6,11,5,11.8z M7.5,5.7c0,0.2-0.2,0.4-0.4,0.4H5.4v1.7C5.4,8,5.2,8.2,5,8.2C4.7,8.2,4.5,8,4.5,7.8V6.1H2.8 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0h1.7V3.5c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v1.7h1.7 C7.3,5.2,7.5,5.4,7.5,5.7z"/> </svg></span>
                            <div class="doctor-data">
                                <h6>Wartezeit</h6>
                                <p>${clinic.waiting_time}</p>
                            </div>
                        </li> <hr>
                    `;
                }

                let insuranceHTML = '';
                if (clinic.insurance_companies.length) {

                    insuranceHTML = `
                        <li class="upper-index">
                            <span class="sg-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 9.9 11.8" style="enable-background:new 0 0 9.9 11.8;" xml:space="preserve"> <path id="health-insurance" d="M5,11.8C7.3,11,8.5,10,9.2,8.3c0.7-1.7,0.8-3.9,0.7-7L5,0L0,1.2c-0.1,3.1,0,5.4,0.7,7 C1.4,10,2.6,11,5,11.8z M7.5,5.7c0,0.2-0.2,0.4-0.4,0.4H5.4v1.7C5.4,8,5.2,8.2,5,8.2C4.7,8.2,4.5,8,4.5,7.8V6.1H2.8 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0h1.7V3.5c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v1.7h1.7 C7.3,5.2,7.5,5.4,7.5,5.7z"/> </svg></span>
                            <div class="doctor-data">
                                <h6>Krankenkassen</h6>
                                ${clinic.insurance_companies.map(insuranceCompany => `<p>- ${insuranceCompany}</p>`).join('')}
                            </div>
                        </li> <hr>
                    `;
                }

                let diagnosticServiceHTML = '';
                if (clinic.diagnostic_services.length) {

                    diagnosticServiceHTML = `
                        <li class="upper-index">
                            <span class="sg-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 9.9 11.8" style="enable-background:new 0 0 9.9 11.8;" xml:space="preserve"> <path id="diagnostic-services" d="M5,11.8C7.3,11,8.5,10,9.2,8.3c0.7-1.7,0.8-3.9,0.7-7L5,0L0,1.2c-0.1,3.1,0,5.4,0.7,7 C1.4,10,2.6,11,5,11.8z M7.5,5.7c0,0.2-0.2,0.4-0.4,0.4H5.4v1.7C5.4,8,5.2,8.2,5,8.2C4.7,8.2,4.5,8,4.5,7.8V6.1H2.8 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0h1.7V3.5c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v1.7h1.7 C7.3,5.2,7.5,5.4,7.5,5.7z"/> </svg></span>
                            <div class="doctor-data">
                                <h6>Diagnostik-Leistungen</h6>
                                ${clinic.diagnostic_services.map(diagnosticService => `<p>- ${diagnosticService}</p>`).join('')}
                            </div>
                        </li><hr>
                    `;
                }

                let specialityHTML = '';
                if (clinic.specialist_areas.length) {

                    specialityHTML = `
                                <li class="upper-index">
                                    <span class="sg-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 12.6 9.6" style="enable-background:new 0 0 12.6 9.6;" xml:space="preserve"> <path d="M10.9,2.4c-0.5-1.3-2-2-3.3-1.5C7.4,1,7.2,1.1,7,1.2C6.3,0,4.7-0.4,3.5,0.4C2.8,0.8,2.4,1.5,2.3,2.2 C1,2.4,0,3.5,0,4.8c0,1.1,0.7,2,1.7,2.4c0.5,1.3,2,2,3.3,1.5c0.2-0.1,0.4-0.2,0.6-0.3C6.3,9.6,7.9,10,9.1,9.2 c0.7-0.4,1.1-1.1,1.2-1.9c1.3-0.2,2.3-1.3,2.3-2.6C12.6,3.7,11.9,2.8,10.9,2.4z M2.6,5.2C2.4,5.2,2.2,5,2.2,4.8 c0-0.2,0.2-0.4,0.4-0.4C2.8,4.4,3,4.6,3,4.8C3,5,2.8,5.2,2.6,5.2C2.6,5.2,2.6,5.2,2.6,5.2z M4.1,6.6c-0.2,0-0.4-0.2-0.4-0.4 c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C4.5,6.5,4.3,6.6,4.1,6.6C4.1,6.6,4.1,6.6,4.1,6.6L4.1,6.6z M4.8,3.7 c-0.2,0-0.4-0.2-0.4-0.4C4.5,3.1,4.6,3,4.8,3C5,3,5.2,3.1,5.2,3.3C5.2,3.5,5,3.7,4.8,3.7C4.8,3.7,4.8,3.7,4.8,3.7L4.8,3.7z M6.3,5.2 C6.1,5.2,5.9,5,5.9,4.8c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C6.7,5,6.5,5.2,6.3,5.2C6.3,5.2,6.3,5.2,6.3,5.2z M7.8,6.6 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C8.1,6.5,8,6.6,7.8,6.6C7.8,6.6,7.8,6.6,7.8,6.6z M8.5,3.7 c-0.2,0-0.4-0.2-0.4-0.4C8.1,3.1,8.3,3,8.5,3c0.2,0,0.4,0.2,0.4,0.4C8.9,3.5,8.7,3.7,8.5,3.7L8.5,3.7z M10,5.2 C9.8,5.2,9.6,5,9.6,4.8c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C10.4,5,10.2,5.2,10,5.2C10,5.2,10,5.2,10,5.2L10,5.2z"/> </svg></span>
                                    <div class="doctor-data">
                                        <h6>Služby</h6>
                                        <p>${clinic.specialist_areas.map(specialist_areas => `<span>- ${specialist_areas}</span><br>`).join('')}</p>
                                    </div>
                                </li>
                            `;
                }

                let therapyServicesHTML = ``;
                let therapyservices = [];
                if (clinic.is_allergy_diagnostic) therapyservices.push('Allergie-Immuntherapie mit: Tabletten');
                if (clinic.is_insect_allergy_diagnostic) therapyservices.push('Insektengift-Immuntherapie');
                if (clinic.is_sublingual_immunotherapy) therapyservices.push('Allergie-Immuntherapie mit: Spritzen');
                if (clinic.is_subcutaneous_immunotherapy) therapyservices.push('Allergie-Immuntherapie mit: Tropfen');

                if (therapyservices.length) {
                    therapyServicesHTML = `
                        <li class="upper-index">
                                <span class="sg-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 12.6 9.6" style="enable-background:new 0 0 12.6 9.6;" xml:space="preserve"> <path d="M10.9,2.4c-0.5-1.3-2-2-3.3-1.5C7.4,1,7.2,1.1,7,1.2C6.3,0,4.7-0.4,3.5,0.4C2.8,0.8,2.4,1.5,2.3,2.2 C1,2.4,0,3.5,0,4.8c0,1.1,0.7,2,1.7,2.4c0.5,1.3,2,2,3.3,1.5c0.2-0.1,0.4-0.2,0.6-0.3C6.3,9.6,7.9,10,9.1,9.2 c0.7-0.4,1.1-1.1,1.2-1.9c1.3-0.2,2.3-1.3,2.3-2.6C12.6,3.7,11.9,2.8,10.9,2.4z M2.6,5.2C2.4,5.2,2.2,5,2.2,4.8 c0-0.2,0.2-0.4,0.4-0.4C2.8,4.4,3,4.6,3,4.8C3,5,2.8,5.2,2.6,5.2C2.6,5.2,2.6,5.2,2.6,5.2z M4.1,6.6c-0.2,0-0.4-0.2-0.4-0.4 c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C4.5,6.5,4.3,6.6,4.1,6.6C4.1,6.6,4.1,6.6,4.1,6.6L4.1,6.6z M4.8,3.7 c-0.2,0-0.4-0.2-0.4-0.4C4.5,3.1,4.6,3,4.8,3C5,3,5.2,3.1,5.2,3.3C5.2,3.5,5,3.7,4.8,3.7C4.8,3.7,4.8,3.7,4.8,3.7L4.8,3.7z M6.3,5.2 C6.1,5.2,5.9,5,5.9,4.8c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C6.7,5,6.5,5.2,6.3,5.2C6.3,5.2,6.3,5.2,6.3,5.2z M7.8,6.6 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C8.1,6.5,8,6.6,7.8,6.6C7.8,6.6,7.8,6.6,7.8,6.6z M8.5,3.7 c-0.2,0-0.4-0.2-0.4-0.4C8.1,3.1,8.3,3,8.5,3c0.2,0,0.4,0.2,0.4,0.4C8.9,3.5,8.7,3.7,8.5,3.7L8.5,3.7z M10,5.2 C9.8,5.2,9.6,5,9.6,4.8c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C10.4,5,10.2,5.2,10,5.2C10,5.2,10,5.2,10,5.2L10,5.2z"/> </svg></span>
                                <div class="doctor-data">
                                    <h6>Therapie-Leistungen</h6>
                                    ${therapyservices.map(therapyservice => `<p>- ${therapyservice}</p>`).join('')} 
                                    <!--  <p>${therapyservices.join('</br>')}</p> -->
                            </div>
                        </li> <hr>
                    `;
                }

                let otherServiceHTML = '';
                if (clinic.other_services.length) {

                    otherServiceHTML = `
                        <li class="upper-index">
                            <span class="sg-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 9.9 11.8" style="enable-background:new 0 0 9.9 11.8;" xml:space="preserve"> <path id="diagnostic-services" d="M5,11.8C7.3,11,8.5,10,9.2,8.3c0.7-1.7,0.8-3.9,0.7-7L5,0L0,1.2c-0.1,3.1,0,5.4,0.7,7 C1.4,10,2.6,11,5,11.8z M7.5,5.7c0,0.2-0.2,0.4-0.4,0.4H5.4v1.7C5.4,8,5.2,8.2,5,8.2C4.7,8.2,4.5,8,4.5,7.8V6.1H2.8 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0h1.7V3.5c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v1.7h1.7 C7.3,5.2,7.5,5.4,7.5,5.7z"/> </svg></span>
                            <div class="doctor-data">
                                <h6>Zusatzservices</h6>
                                ${clinic.other_services.map(otherServices => `<p>- ${otherServices}</p>`).join('')}
                            </div>
                        </li> <hr>
                    `;
                }

                let onlineAppointmentURL = '';
                if (clinic.online_appointment_url) {

                    onlineAppointmentURL = `
                        <a class="btn-outline-jungle font-weight-normal sg-btn upper-index online-appointment-click font-poppins-regular" id="card-onlinebook-${clinic.id}"
                            target="_blank"
                            href="${clinic.online_appointment_url}"
                        >
                            <span>Online-Buchung</span>
                        </a>
                    `;
                }

                let beeIconHTML = '';
                if (clinic.specialist_areas.length) {
                    if (clinic.specialist_areas.includes(' Specialista nabodnutí hmyzem')) {
                        beeIconHTML = `<li class="profile-image position-absolute">                     
                            <img class="w-100 h-100" src="https://cdn.shopify.com/s/files/1/0614/8577/7138/files/bee.png?v=1658519075" alt="Avtar">
                        </li>`;
                    }
                }

                let name = (`${clinic.doctor_name ? clinic.doctor_name : ''}`).trim();
                let clinicname = (`${clinic.clinic_name? clinic.clinic_name : ''}`).trim();

                let clinicPageUrl = '';
                if (this.fadIframe) {
                    clinicPageUrl = `<span class="clinic-click">${name}</span>`;
                }
                else{
                    clinicPageUrl = `<a class="clinic-click" href="/apps/pages/${this.clinicPagePrefix}/${clinic.doctor_handle}">${name}</a>`;
                }

                let clinicHTML = `
                            <div id="clinic-${clinic.id}" class="search-data-block fordatalayer" data-id="${clinic.id}" data-clinic-name="${clinic.clinic_name}" data-doctor-name="${clinic.doctor_name}" data-doctor-handle="${clinic.doctor_handle}" data-zip="${clinic.zipcode}" data-state="${clinic.state}">
    <!--                              <div class="lower-index marker-trigger" data-index="${index}"></div>-->
                                <h4 class="upper-index">${clinicPageUrl}</h4>
                                <p class="description mb-1">${clinicname}</p>                            
                                <ul class="contact-info position-relative">
                                    ${beeIconHTML}
                                    ${emailHTML}
                                    ${phoneHTML}
                                    <li class="upper-index">
                                        <span class="sg-icon"><svg id="maps-and-flags" xmlns="http://www.w3.org/2000/svg" width="12.313" height="17" viewBox="0 0 12.313 17">
                                        <g id="Group_3438" data-name="Group 3438">
                                            <path id="Path_11578" data-name="Path 11578" d="M76.73,0a6.164,6.164,0,0,0-6.157,6.157c0,4.213,5.51,10.4,5.744,10.659a.555.555,0,0,0,.825,0c.235-.261,5.744-6.446,5.744-10.659A6.164,6.164,0,0,0,76.73,0Zm0,9.254a3.1,3.1,0,1,1,3.1-3.1A3.1,3.1,0,0,1,76.73,9.254Z" transform="translate(-70.573)" fill="#a9a9a9"/>
                                        </g>
                                        </svg>
                                        </span>
                                        <address>${clinic.street},<br/> ${this.capitalize(clinic.city)}, ${clinic.state ? clinic.state.toUpperCase() : ''} ${clinic.zipcode}</address>
                                    </li>  
                                    ${websiteHTML}                              
                                </ul>
                                
                                <div class="sg-btn-wrapper">
                                    <a class="sg-btn sg-btn-secondary sg-me-2 direction-btn upper-index  sg-me-auto" id="card-direction-${clinic.id}" target="_blank" href="https://www.google.com/maps/dir/${this.userLocation.lat},${this.userLocation.lng}/${clinic.latitude},${clinic.longitude}/data=!3m1!4b1!4m2!4m1!3e0"><span>Trasa</span> <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve"> <path d="M15.8,7.4L15.8,7.4L8.6,0.2c-0.3-0.3-0.8-0.3-1.1,0L0.2,7.4c-0.3,0.3-0.3,0.8,0,1.1c0,0,0,0,0,0l7.2,7.2 l0,0c0.3,0.3,0.8,0.3,1.1,0c0,0,0,0,0,0l7.2-7.2C16.1,8.3,16.1,7.7,15.8,7.4C15.8,7.4,15.8,7.4,15.8,7.4z M9.6,10V8H6.4v2.4H4.8V7.2 c0-0.4,0.4-0.8,0.8-0.8c0,0,0,0,0,0h4v-2l2.8,2.8L9.6,10z"/> </svg></a>
                                    <!--a class="sg-btn sg-btn-secondary sg-btn-outline text-uppercase upper-index">OB</a-->
                                    ${onlineAppointmentURL}
                                    <span data-index="${index}" id="panelbtn-${clinic.id}" class="sg-icon-btn detail-btn sg-btn-primary sg-ms-2 extra-info-btn upper-index doctor-detail-click"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 11.6 6.8" style="enable-background:new 0 0 11.6 6.8;" xml:space="preserve"> <path d="M0.3,0.3c0.4-0.4,1.1-0.5,1.5-0.1c0,0,0,0,0.1,0.1l3.9,3.8l3.9-3.7 c0.4-0.4,1.1-0.5,1.5-0.1c0,0,0,0,0.1,0.1c0.4,0.5,0.4,1.2,0,1.6c-0.4,0.4-4.7,4.5-4.7,4.5C6.2,6.9,5.5,6.9,5,6.5c0,0,0,0,0,0 c0,0-4.3-4.1-4.7-4.5C-0.1,1.5-0.1,0.8,0.3,0.3L0.3,0.3z"/> </svg></span>
                                </div>
                                <div class="extra-info d-none" id="panel-${clinic.id}">
                                    <ul class="contact-info">
                                        ${specialityHTML}
                                        ${diagnosticServiceHTML}
                                        ${therapyServicesHTML}
                                        ${otherServiceHTML}
                                        ${waitingTimeHTML}
                                        ${insuranceHTML}
                                        ${timingsHTML}
                                    </ul>
                                </div>
                            </div>
                        `;
                clinicsHTML += clinicHTML;
            }
            if (initializeMarkers && clinic.latitude && clinic.longitude) {
                let marker = new mapboxgl.Marker({
                    color: "#01e6cf"
                })
                    .setLngLat([
                        parseFloat(clinic.longitude),
                        parseFloat(clinic.latitude)
                    ])
                    .addTo(this.map);

                marker.id = clinic.id;
                marker.distance = clinic.distance;
                marker.latitude = clinic.latitude;
                marker.longitude = clinic.longitude;
                marker._element.id = 'pin-'+ clinic.id;
                let popup = new mapboxgl.Popup().setHTML(this.setMarkerPopup(clinic));
                marker._element.addEventListener('click', (event) => {
                    if (!event.pointerType) return;

                    this.manageDataLayers('fad-pin-click', event, clinic);
                });

                popup.on('open', () => this.handlePopupOpen(clinic, marker));
                popup.on('close', () => this.handlePopupClose(clinic, marker));

                marker.setPopup(popup);
                this.markers.push(marker);
            }
        });

        if (clinicsHTML) {
            let loadingTextEl = document.getElementById('loading-text');
            if(loadingTextEl) loadingTextEl.classList.remove('d-md-block');

            let clinicsResultEl = document.getElementById('fad-map-list');
            if (clinicsResultEl) clinicsResultEl.innerHTML = clinicsHTML;
        }

        if(!this.fadWidget) this.bindCardDetailEvents();
    }

    handleCardClick(event, doctorID, clinicEl, clinicElIndex) {

        this.clinic = this.clinics.find(item => item.id === doctorID);

        if (this.marker && this.marker.getPopup().isOpen()) {
            this.marker.togglePopup();
        }

        this.markers[clinicElIndex].togglePopup();
        this.marker = this.markers[clinicElIndex];

        this.manageDataLayers('fad-card-viewed', event, this.clinic);
    }

    handlePopupOpen(clinic, marker) {

        if (!clinic || !marker) return;

        let markerPopupElement = marker._popup._container || null;
        if (markerPopupElement) this.bindCardDetailEvents(markerPopupElement);

        this.clinic = clinic;
        this.marker = marker;

        this.manageMarkerPosition(marker);
        if(document.getElementById('fad-map-list')) {

            document.querySelectorAll('.search-data-block.active').forEach(element => element.classList.remove('active'));

            let currentEl = document.querySelector(`#clinic-${clinic.id}`);
            currentEl.classList.add('active');
            document.querySelectorAll('.search-data-block').forEach((element) => {
                if (!element.classList.contains('active')) {
                    element.classList.remove('details-open');
                    element.querySelector('.extra-info').classList.add('d-none');
                }
            });

            document.getElementById('fad-map-list').scroll(0, (currentEl.offsetTop - document.getElementById('fad-map-list').offsetTop));
        }

        // Pass name into query string
        this.manageURL({
            name: clinic.doctor_name
        }, true);

        // marker._color = '#02b7a5';

        document.querySelectorAll('.mapboxgl-marker.mapboxgl-marker-anchor-center.active-marker')
            .forEach(element => element.classList.remove('active-marker'));

        this.marker._element.classList.add('active-marker');
    }

    handlePopupClose(clinic, marker) {
        if (!clinic || !marker) return;
        marker._element.classList.remove('active-marker');

        let clinicEl = document.querySelector(`#fad-map-list .search-data-block[data-doctor-name ="${clinic.doctor_name}"]`);
        if (clinicEl) clinicEl.classList.remove('active');
    }

    manageMarkerPosition(marker) {

        try {
            if (!marker) return;

            const listBoxEl = document.querySelector('.fad-list-primary-block');

            let markerOutside = !this.map.getBounds().contains(marker.getLngLat());
            markerOutside = markerOutside ? markerOutside : !this.isElementCovered(this.map._container, marker._element);

            let popupOutside = !this.isElementCovered(this.map._container, marker._popup._container);
            let headerElementOutside = !this.isElementCovered(this.map._container, marker._popup._container.querySelector('.mappopup-header'));
            let footerElementOutside = !this.isElementCovered(this.map._container, marker._popup._container.querySelector('.doctor-popup-detail-click'));

            let offset = new mapboxgl.Point(0, -100);

            if(!this.isMobile) {

                let intersectWithList = this.isElementsIntersecting(listBoxEl, marker._popup._container);
                if (markerOutside || headerElementOutside || footerElementOutside || popupOutside || intersectWithList) {

                    if (this.isTablet) {
                        offset = new mapboxgl.Point(200, -100);
                    }

                    this.map.panTo(marker.getLngLat(), { offset: offset });
                }
            } else {
                let intersectWithSwitch = this.isElementsIntersecting(document.querySelector('#list-change-btn-wrapper'), marker._popup._container.querySelector('.doctor-popup-detail-click'));

                if (markerOutside || headerElementOutside || footerElementOutside || popupOutside || intersectWithSwitch) {

                    this.map.panTo(marker.getLngLat(), { offset: offset });
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    setMarkerPopup(clinic) {

        let phoneHTML = '';
        if (clinic.phone) {

            phoneHTML = `
                    <li>
                        <span class="mappopup-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 10 10" style="enable-background:new 0 0 10 10;" xml:space="preserve"> <g transform="translate(0)"> <path d="M9.2,6.6C8.6,6.6,8,6.5,7.4,6.3c-0.3-0.1-0.6,0-0.8,0.2L5.5,7.3C4.3,6.7,3.3,5.7,2.7,4.5l0.8-1.1 c0.2-0.2,0.3-0.5,0.2-0.8C3.5,2,3.4,1.4,3.4,0.8C3.4,0.4,3.1,0,2.6,0H0.8C0.4,0,0,0.4,0,0.8C0,5.9,4.1,10,9.2,10 C9.6,10,10,9.6,10,9.2l0,0V7.4C10,6.9,9.6,6.6,9.2,6.6C9.2,6.6,9.2,6.6,9.2,6.6z"/> </g> </svg></span>
                        <a class="doc-phone text-primary" id="popup-phone-${clinic.id}"  href="tel:${clinic.phone}">${clinic.phone.replace('(','').replace(')','')}</a>
                    </li>
                `;
        }

        let emailHTML = '';
        if (clinic.email) {

            emailHTML = `
                    <li>
                        <span class="mappopup-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 11.5 8.6" style="enable-background:new 0 0 11.5 8.6;" xml:space="preserve"> <g transform="translate(0 -64.266)"> <path d="M6.7,69.8c-0.6,0.4-1.3,0.4-1.9,0l-4.7-3.1c0,0-0.1,0-0.1-0.1v5.1c0,0.6,0.5,1.1,1.1,1.1c0,0,0,0,0,0h9.3 c0.6,0,1.1-0.5,1.1-1.1c0,0,0,0,0,0v-5.1c0,0-0.1,0-0.1,0.1L6.7,69.8z"/> <path d="M0.4,66.2l4.7,3.1c0.4,0.2,0.8,0.2,1.2,0l4.7-3.1c0.3-0.2,0.5-0.5,0.4-0.8c0-0.6-0.5-1.1-1.1-1.1 c0,0,0,0,0,0H1.1c-0.6,0-1.1,0.5-1.1,1.1C0,65.7,0.2,66,0.4,66.2z"/> </g> </svg></span>
                        <a class="doc-email text-primary" id="popup-email-${clinic.id}" href="mailto:${clinic.email}">${clinic.email}</a>
                    </li>
                `;
        }

        let websiteHTML = '';
        if (clinic.website) {

            websiteHTML = `<li>
                              <span class="mappopup-icon">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20.1 20.1" style="enable-background:new 0 0 20.1 20.1;" xml:space="preserve">
                                    <path d="M17.1,3C13.2-1,6.9-1,3,2.9S-1,13.1,2.9,17c0,0,0,0,0.1,0.1c3.9,3.9,10.2,4,14.1,0.1S21.1,6.9,17.1,3 C17.1,3,17.1,3,17.1,3z M3.8,3.8c0.9-0.9,1.9-1.5,3-2C6.5,2.2,6.2,2.6,6,3.1C5.7,3.7,5.4,4.3,5.2,4.9c-0.7-0.1-1.4-0.3-2-0.5 C3.4,4.2,3.6,4,3.8,3.8z M2.5,5.5c0.8,0.2,1.6,0.4,2.4,0.6C4.6,7.2,4.5,8.3,4.5,9.4H1.2C1.3,8,1.7,6.7,2.5,5.5z M2.4,14.5 c-0.7-1.2-1.1-2.5-1.2-3.9h3.2c0,1.1,0.2,2.2,0.4,3.3C4.1,14,3.2,14.2,2.4,14.5z M3.8,16.3c-0.2-0.2-0.5-0.5-0.7-0.8 c0.7-0.2,1.4-0.3,2.1-0.4c0.2,0.6,0.5,1.3,0.8,1.9c0.3,0.5,0.6,1,0.9,1.4C5.7,17.8,4.7,17.2,3.8,16.3L3.8,16.3z M9.4,18.7 c-1.1-0.4-2-1.3-2.4-2.4c-0.2-0.5-0.5-1-0.6-1.5c1-0.1,2-0.2,3-0.2V18.7z M9.4,13.5c-1.1,0-2.3,0.1-3.4,0.2c-0.2-1-0.4-2.1-0.4-3.1 h3.8L9.4,13.5L9.4,13.5z M9.4,9.4H5.6c0-1.1,0.2-2.2,0.4-3.2c1.1,0.1,2.2,0.2,3.4,0.2V9.4z M9.4,5.3c-1.1,0-2.1-0.1-3-0.2 c0.2-0.5,0.4-1,0.6-1.5c0.5-1.1,1.3-1.9,2.4-2.4V5.3L9.4,5.3z M17.6,5.5c0.7,1.2,1.1,2.5,1.2,3.9h-3.2c0-1.1-0.2-2.2-0.4-3.3 C16,6,16.8,5.8,17.6,5.5L17.6,5.5z M16.3,3.8c0.2,0.2,0.5,0.5,0.7,0.7c-0.7,0.2-1.4,0.3-2.1,0.4c-0.2-0.6-0.5-1.3-0.8-1.9 c-0.2-0.5-0.5-0.9-0.8-1.3C14.4,2.2,15.4,2.9,16.3,3.8z M10.6,10.6h3.8c0,1.1-0.2,2.1-0.4,3.1c-1.1-0.1-2.2-0.2-3.4-0.2L10.6,10.6z M10.6,9.4v-3c1.1,0,2.3-0.1,3.4-0.2c0.2,1,0.4,2.1,0.4,3.2L10.6,9.4L10.6,9.4z M10.6,1.3L10.6,1.3c1.1,0.4,2,1.3,2.4,2.4 c0.2,0.5,0.5,1,0.6,1.5c-1,0.1-2,0.2-3.1,0.2L10.6,1.3z M10.6,18.7v-4c1.1,0,2.1,0.1,3,0.2c-0.2,0.5-0.4,1-0.6,1.4 C12.6,17.4,11.7,18.3,10.6,18.7z M16.3,16.3c-0.9,0.9-1.9,1.6-3.1,2c0.4-0.4,0.7-0.9,0.9-1.4c0.3-0.6,0.6-1.2,0.8-1.8 c0.7,0.1,1.4,0.3,2.1,0.5C16.7,15.8,16.5,16,16.3,16.3L16.3,16.3z M17.6,14.5c-0.8-0.3-1.6-0.4-2.5-0.6c0.3-1.1,0.4-2.2,0.4-3.3h3.2 C18.7,12,18.3,13.3,17.6,14.5L17.6,14.5z"/>
                                </svg>
                              </span>
                              <a class="website-click text-primary" id="popup-website-${clinic.id}" target="_blank" href="${clinic.website}">
                                <u>Webové stránky</u>
                              </a>
                            </li>`;
        }

        let classNone = (`${this.fadIframe ? 'd-none' : ''}`).trim();

        let onlineAppointmentURL = '';
        let popupDetailBtn = '';
        if (clinic.online_appointment_url) {

            onlineAppointmentURL = `
                    <a class="btn-outline-jungle font-weight-normal sg-btn upper-index online-appointment-click font-poppins-regular" id="popup-onlinebook-${clinic.id}"
                        target="_blank"
                        href="${clinic.online_appointment_url}"
                    >
                        <span>Online-Buchung</span>
                    </a>
                `;

            popupDetailBtn = `
                <li>
                    <span class="mappopup-icon popup-details">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                            <g>
                                <g>
                                    <g>
                                        <path d="M290.211,360.727c-5.234,0.488-10.489-0.693-15.011-3.375c-3.304-3.392-4.888-8.101-4.305-12.8     c0.122-3.912,0.589-7.806,1.396-11.636c0.781-4.394,1.79-8.744,3.025-13.033l13.731-47.244c1.416-4.663,2.352-9.459,2.793-14.313     c0-5.236,0.698-8.844,0.698-10.938c0.292-9.333-3.693-18.289-10.822-24.32c-8.769-6.732-19.689-10.041-30.72-9.309     c-7.905,0.119-15.749,1.413-23.273,3.84c-8.223,2.56-16.873,5.624-25.949,9.193l-3.956,15.36     c2.676-0.931,5.935-1.978,9.658-3.142c3.552-1.052,7.234-1.601,10.938-1.629c5.196-0.563,10.426,0.713,14.778,3.607     c2.956,3.527,4.343,8.109,3.84,12.684c-0.013,3.913-0.442,7.814-1.28,11.636c-0.815,4.073-1.862,8.378-3.142,12.916     l-13.847,47.476c-1.116,4.413-2.009,8.879-2.676,13.382c-0.544,3.855-0.816,7.743-0.815,11.636     c-0.057,9.397,4.24,18.291,11.636,24.087c8.904,6.837,19.98,10.226,31.185,9.542c7.89,0.162,15.753-0.978,23.273-3.375     c6.594-2.25,15.399-5.469,26.415-9.658l3.724-14.662c-2.984,1.238-6.057,2.249-9.193,3.025     C298.346,360.583,294.274,360.935,290.211,360.727z"></path>
                                        <path d="M304.756,136.727c-6.333-5.816-14.677-8.945-23.273-8.727c-8.591-0.194-16.927,2.932-23.273,8.727     c-11.632,10.03-12.931,27.591-2.9,39.224c0.894,1.037,1.863,2.006,2.9,2.9c13.252,11.853,33.294,11.853,46.545,0     c11.632-10.129,12.851-27.769,2.722-39.401C306.635,138.481,305.725,137.571,304.756,136.727z"></path>
                                        <path d="M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.615,256-256S397.385,0,256,0z M256,488.727     C127.468,488.727,23.273,384.532,23.273,256S127.468,23.273,256,23.273S488.727,127.468,488.727,256S384.532,488.727,256,488.727     z"></path>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </span>
                    <a class="doctor-popup-detail-click text-primary ${classNone}"  href="/apps/pages/${this.clinicPagePrefix}/${clinic.doctor_handle}" id="details-btn-${clinic.id}">
                    <u>Podrobnosti</u>
                    </a>
                </li> `;
        }
        else {
            popupDetailBtn = `
                <a href="/apps/pages/${this.clinicPagePrefix}/${clinic.doctor_handle}" class="icon-btns details-btn doctor-popup-detail-click ${classNone}" id="details-btn-${clinic.id}"><span>Podrobnosti</span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 11.6 6.8" style="enable-background:new 0 0 11.6 6.8;" xml:space="preserve"><path d="M0.3,0.3c0.4-0.4,1.1-0.5,1.5-0.1c0,0,0,0,0.1,0.1l3.9,3.8l3.9-3.7 c0.4-0.4,1.1-0.5,1.5-0.1c0,0,0,0,0.1,0.1c0.4,0.5,0.4,1.2,0,1.6c-0.4,0.4-4.7,4.5-4.7,4.5C6.2,6.9,5.5,6.9,5,6.5c0,0,0,0,0,0 c0,0-4.3-4.1-4.7-4.5C-0.1,1.5-0.1,0.8,0.3,0.3L0.3,0.3z"/></svg></span></a>
            `;
        }

        let timingsHTML = '';
        if (clinic.timings.length) {

            let daysHTML = '';
            clinic.timings.forEach(clinicTiming => {

                daysHTML += `<p>${clinicTiming.translations.de}: `;
                clinicTiming.opening_hours.forEach((openingHour, i) => {

                    if (i > 0) daysHTML += `and `;
                    daysHTML += `${openingHour.opening_time} - ${openingHour.closing_time} `;
                });
                daysHTML += `</p>`;
            });

            timingsHTML = `
                    <li>
                        <span class="mappopup-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 12 12" style="enable-background:new 0 0 12 12;" xml:space="preserve"> <path d="M6,0C2.7,0,0,2.7,0,6s2.7,6,6,6s6-2.7,6-6S9.3,0,6,0z M8,8C7.8,8.2,7.5,8.2,7.3,8c0,0,0,0,0,0L5.6,6.4 C5.5,6.3,5.5,6.1,5.5,6V2.7c0-0.3,0.2-0.5,0.5-0.5c0.3,0,0.5,0.2,0.5,0.5v3L8,7.3C8.2,7.5,8.2,7.8,8,8C8,8,8,8,8,8z"/> </svg></span>
                        <div class="extradetails-wrapper">
                            <h6 class="h5">Office hours</h6>
                            ${daysHTML}
                        </div>
                    </li>
                `;
        }

        let insuranceHTML = '';
        if (clinic.insurance_companies.length) {

            insuranceHTML = `
                    <li>
                        <span class="mappopup-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 9.9 11.8" style="enable-background:new 0 0 9.9 11.8;" xml:space="preserve"> <path id="health-insurance" d="M5,11.8C7.3,11,8.5,10,9.2,8.3c0.7-1.7,0.8-3.9,0.7-7L5,0L0,1.2c-0.1,3.1,0,5.4,0.7,7 C1.4,10,2.6,11,5,11.8z M7.5,5.7c0,0.2-0.2,0.4-0.4,0.4H5.4v1.7C5.4,8,5.2,8.2,5,8.2C4.7,8.2,4.5,8,4.5,7.8V6.1H2.8 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0h1.7V3.5c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4v1.7h1.7 C7.3,5.2,7.5,5.4,7.5,5.7z"/> </svg></span>
                        <div class="extradetails-wrapper">
                            <h6>Insurance Companies</h6>
                            ${clinic.insurance_companies.map(insuranceCompany => `<p>- ${insuranceCompany}</p>`).join('')}
                        </div>
                    </li>
                `;
        }

        let specialityHTML = '';
        if (clinic.specialist_areas.length) {

            specialityHTML = `
                    <li>
                        <span class="mappopup-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 12.6 9.6" style="enable-background:new 0 0 12.6 9.6;" xml:space="preserve"> <path d="M10.9,2.4c-0.5-1.3-2-2-3.3-1.5C7.4,1,7.2,1.1,7,1.2C6.3,0,4.7-0.4,3.5,0.4C2.8,0.8,2.4,1.5,2.3,2.2 C1,2.4,0,3.5,0,4.8c0,1.1,0.7,2,1.7,2.4c0.5,1.3,2,2,3.3,1.5c0.2-0.1,0.4-0.2,0.6-0.3C6.3,9.6,7.9,10,9.1,9.2 c0.7-0.4,1.1-1.1,1.2-1.9c1.3-0.2,2.3-1.3,2.3-2.6C12.6,3.7,11.9,2.8,10.9,2.4z M2.6,5.2C2.4,5.2,2.2,5,2.2,4.8 c0-0.2,0.2-0.4,0.4-0.4C2.8,4.4,3,4.6,3,4.8C3,5,2.8,5.2,2.6,5.2C2.6,5.2,2.6,5.2,2.6,5.2z M4.1,6.6c-0.2,0-0.4-0.2-0.4-0.4 c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C4.5,6.5,4.3,6.6,4.1,6.6C4.1,6.6,4.1,6.6,4.1,6.6L4.1,6.6z M4.8,3.7 c-0.2,0-0.4-0.2-0.4-0.4C4.5,3.1,4.6,3,4.8,3C5,3,5.2,3.1,5.2,3.3C5.2,3.5,5,3.7,4.8,3.7C4.8,3.7,4.8,3.7,4.8,3.7L4.8,3.7z M6.3,5.2 C6.1,5.2,5.9,5,5.9,4.8c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C6.7,5,6.5,5.2,6.3,5.2C6.3,5.2,6.3,5.2,6.3,5.2z M7.8,6.6 c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C8.1,6.5,8,6.6,7.8,6.6C7.8,6.6,7.8,6.6,7.8,6.6z M8.5,3.7 c-0.2,0-0.4-0.2-0.4-0.4C8.1,3.1,8.3,3,8.5,3c0.2,0,0.4,0.2,0.4,0.4C8.9,3.5,8.7,3.7,8.5,3.7L8.5,3.7z M10,5.2 C9.8,5.2,9.6,5,9.6,4.8c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4C10.4,5,10.2,5.2,10,5.2C10,5.2,10,5.2,10,5.2L10,5.2z"/> </svg></span>
                        <div class="extradetails-wrapper">
                            <h6 class="h5">SPECIALIZATION AREAS</h6>
                            <p>${clinic.specialist_areas.map(specialist_areas => `<span>- ${specialist_areas}</span>`).join('')}</p>
                        </div>
                    </li>
                `;
        }

        return `
                <div class="fad-mappopup fordatalayer" data-id="${clinic.id}" data-doctor-name="${clinic.doctor_name}" data-state="${clinic.state}">
                    <div class="mappopup-header">
                        <h3 class="h2">${clinic.doctor_name ? clinic.doctor_name : clinic.clinic_name}</h3>
                        <p class="mt-1 mb-1">${clinic.clinic_name? clinic.clinic_name : ''}</p>                        
                    </div>
                    <div class="mappopup-body">
                        <ul class="mappopup-contact-details">
                            ${emailHTML}
                            ${phoneHTML} 
                            <li>
                                <span class="mappopup-icon"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"viewBox="0 0 9 12" style="enable-background:new 0 0 9 12;" xml:space="preserve"> <path d="M4.5,0C2.1,0,0,1.9,0,4.3c0,3,4,7.3,4.2,7.5c0.2,0.2,0.4,0.2,0.6,0c0,0,0,0,0,0C5,11.7,9,7.3,9,4.3 C9,1.9,6.9,0,4.5,0z M4.5,6.5c-1.2,0-2.2-1-2.3-2.2c0-1.3,1.1-2.2,2.3-2.2c1.2,0,2.2,1,2.2,2.2C6.7,5.6,5.7,6.6,4.5,6.5z"/> </svg></span>
                                <address>${clinic.street},<br/> ${this.capitalize(clinic.city)}, ${clinic.state ? clinic.state.toUpperCase() : ''} ${clinic.zipcode}</address>
                            </li>
                            ${websiteHTML}
                            ${clinic.online_appointment_url ? popupDetailBtn : ''}

                        </ul>
                        <div class="mappopup-btn-wrapper mb-2 justify-content-between mx-1">
                            <a href="https://www.google.com/maps/dir/${this.userLocation.lat},${this.userLocation.lng}/${clinic.latitude},${clinic.longitude}/data=!3m1!4b1!4m2!4m1!3e0" target="_blank" id="popup-direction-${clinic.id}"  class="sg-btn icon-btns direction-btn mr-2"><span>Trasa</span><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve"><path d="M15.8,7.4L15.8,7.4L8.6,0.2c-0.3-0.3-0.8-0.3-1.1,0L0.2,7.4c-0.3,0.3-0.3,0.8,0,1.1c0,0,0,0,0,0l7.2,7.2\tl0,0c0.3,0.3,0.8,0.3,1.1,0c0,0,0,0,0,0l7.2-7.2C16.1,8.3,16.1,7.7,15.8,7.4C15.8,7.4,15.8,7.4,15.8,7.4z M9.6,10V8H6.4v2.4H4.8V7.2\tc0-0.4,0.4-0.8,0.8-0.8c0,0,0,0,0,0h4v-2l2.8,2.8L9.6,10z"/></svg></a>  
                            ${onlineAppointmentURL}
                            ${!clinic.online_appointment_url ? popupDetailBtn : ''}
                        </div>
                    </div> 
                    <div class="mappopup-extradetails d-none" id="details-div-${clinic.id}">
                        <ul class="mappopup-contact-details">
                            ${timingsHTML}
                            ${insuranceHTML}
                            ${specialityHTML}
                        </ul>
                    </div>
                </div>
            `;
    }

    clearRecords() {
        this.marker = null;
        let markerLength = this.markers.length;
        for (let i = 0; i < markerLength; i++) {
            this.markers[i].remove();
        }
        this.markers = [];
        this.clinics = [];
        this.clinic = null;
    }
    async processMap() {
        this.setAutocomplete();
        this.initializeMap();

        // this.manageDataLayers('fad-map-load');

        await this.handleMapChange();
        this.bindMapEvents();
    }

    setAutocomplete() {
        const geocoder = new MapboxGeocoder({
            accessToken: window.mapBoxAPIKey,
            types: 'country,region,place,postcode,locality,neighborhood',
            countries: 'CZ',
            language: 'cs',
            placeholder: 'Zadejte svou polohu',
        });

        geocoder.addTo('#fad-search');
        geocoder._inputEl.value = this.searchValue;

        geocoder.on('result', async (response) => {
            await this.handleSearch(response);
        });
    }

    initializeMap() {
        this.map = new mapboxgl.Map({
            attributionControl: false,
            cooperativeGestures: true,
            dragRotate: false,
            accessToken: window.mapBoxAPIKey,
            container: 'fad-map',
            style: 'mapbox://styles/mapbox/streets-v11',
            center: {
                lon: this.userLocation.lng,
                lat: this.userLocation.lat
            },
            zoom: this.zoom ? this.zoom : window.defaultZoom,
            language: 'cs',
            maxBounds: [[window.countryBounds.west, window.countryBounds.south], [window.countryBounds.east, window.countryBounds.north]]
        });
        this.map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
    }

    async handleMapChange() {

        if (!this.firstLoad) return;
        if (this.isCityPage && !this.firstLoad) return;

        let mapCenter = this.map.getCenter();
        this.apiParams.lat = mapCenter.lat;
        this.apiParams.lng = mapCenter.lng;

        // this.apiParams.radius = this.getDistance();

        if (this.searchValue) await this.updateRecords();
    }

    bindMapEvents() {
        this.zoom = this.map.getZoom();
        let oldZoomLevel = 0;

        this.map.on('zoomend', async (event) => {

            if (!(event && event.originalEvent)) return;

            let zoomLevel = this.map.getZoom();
            if (oldZoomLevel === zoomLevel) return;

            oldZoomLevel = zoomLevel;

            if(this.zoom > zoomLevel) {

                this.manageDataLayers('fad-map-interaction', event, 'zoomOut');
            }
            else {

                this.manageDataLayers('fad-map-interaction', event, 'zoomIn');
            }

            this.zoom = zoomLevel;
            // await this.handleMapChange();

            let zoom = parseFloat(zoomLevel.toFixed(2));
            if (zoom > 0) this.manageURL({
                zoom: zoom
            }, true);
        });

        this.map.on('dragend', async (event) => {

            if (!(event && event.originalEvent)) return;

            this.manageDataLayers('fad-map-interaction', event, 'move');

            // await this.handleMapChange();
        });
    }

    handleSearchInputClick(event) {
        if (!event) return;

        let element = event.target;
        if (!element) return;

        element.value = '';
        element.setAttribute('data-search', '');
    }

    async fadWidgetSearchBtnClick(){
        if (this.searchValue) {
            await this.map.setZoom(window.defaultZoom);
            await this.fitMapBounds(this.searchBbox, this.apiParams);
            await this.handleRedirectOrUpdate();
            setTimeout(async () => {
                await this.updateRecords();
            }, 0);
        }
    }

    async handleSearch(response) {

        let result = response.result;
        if (!result) return;

        let placeName = result.text ? result.place_name : result.text;

        this.manageDataLayers('fad-search-location', null, placeName);

        this.searchValue = placeName;
        document.getElementById('fad-search').setAttribute('data-search', this.searchValue);

        if (this.searchValue) {
            await this.map.setZoom(window.defaultZoom);

            this.apiParams.lat = result.geometry.coordinates[1] || '';
            this.apiParams.lng = result.geometry.coordinates[0] || '';
            this.searchBbox = result.bbox;

            await this.fitMapBounds(result.bbox, this.apiParams);

            // if (result.bbox) await this.map.fitBounds(result.bbox);
            // else {
            //     await this.map.fitBounds(new mapboxgl.LngLatBounds(
            //         [this.apiParams.lng - 0.01, this.apiParams.lat - 0.01],
            //         [this.apiParams.lng + 0.01, this.apiParams.lat + 0.01]
            //     ), {
            //         padding: {
            //             top: 50, bottom: 50, left: 50, right: 50
            //         }
            //     });
            // }

            // this.apiParams.radius = this.getDistance();

            await this.handleRedirectOrUpdate();

            // await this.handleSortByDistance(distanceFromLeft);
            setTimeout(async () => {
                await this.updateRecords();
            }, 0);
        }
    }

    async handleSortByDistance(distance) {
        this.markers.forEach((marker, i) => {
            if (marker.getPopup().isOpen()) marker.togglePopup();
        });

        this.clinics.sort((a, b) => Math.abs(a.distance - distance) - Math.abs(b.distance - distance));
        this.markers.sort((a, b) => Math.abs(a.distance - distance) - Math.abs(b.distance - distance));

        this.prepareClinicListHTML();

        let highlightClinicIndex = 0;

        if (this.clinics.length) {
            let name = this.clinics[highlightClinicIndex].doctor_name;
            let clinicEl = document.querySelector(`#fad-map-list .search-data-block[data-doctor-name ="${name}"]`);
            if (clinicEl) clinicEl.classList.add('active');
            this.markers[highlightClinicIndex].togglePopup();
        }
    }

    async handleRedirectOrUpdate() {
        let pageHandle = window.location.href.substring(window.location.href.lastIndexOf('/') + 1).split('?')[0];
        if (document.getElementById('fad-map-full') && pageHandle !== this.fadPrefix && pageHandle !== '' && !this.fadIframe) {
            window.location.href = `/pages/${this.fadPrefix}?address=${this.searchValue}&latitude=${this.apiParams.lat}&longitude=${this.apiParams.lng}`;
        }
    }

    manageSwitchView(event) {

        if (!event) return;
        let currentElement = event.currentTarget;
        let type = currentElement.getAttribute('data-view');

        this.manageDataLayers('fad-switch-view', event, type);

        if (this.isMobile) {

            if(type === 'map') document.getElementById('map-block').classList.remove('d-none');
            else document.getElementById('map-block').classList.add('d-none');

            this.manageMarkerPosition(this.marker);
        }

        if (type === 'map') document.querySelector('.fad-list-search-body').classList.add('d-none');
        else document.querySelector('.fad-list-search-body').classList.remove('d-none');

        if (this.isMobile && this.clinic) {
            let currentEl = document.querySelector(`#clinic-${this.clinic.id}`);
            if (currentEl) {
                document.querySelectorAll('.search-data-block.active').forEach(element => element.classList.remove('active'));
                currentEl.classList.add('active');
                document.getElementById('fad-map-list').scroll(0, (currentEl.offsetTop - document.getElementById('fad-map-list').offsetTop));
            }
        }

        document.querySelectorAll('#list-change-btn [data-view]').forEach(el => el.classList.remove('d-none'));
        currentElement.classList.add('d-none');
    }

    openFilter() {
        document.getElementById('fad-list-filter-block').classList.remove('d-none');
        if (this.isMobile) {
            document.querySelector('.fad-list-search-body').classList.add('d-none');
            document.getElementById('map-block').classList.add('d-none');

            let listChangeBtn = document.querySelector('#list-change-btn-wrapper');
            if (listChangeBtn) listChangeBtn.classList.add('d-none');

        } else {
            document.querySelector('.fad-list-search-body').classList.remove('d-md-block');
        }
        document.getElementById('fad-filters-btn').classList.add('active-up');
    }

    closeFilter() {

        let filterBtn = document.getElementById('fad-filters-btn');

        document.getElementById('fad-list-filter-block').classList.add('d-none');
        filterBtn.classList.remove('active-up');

        if (this.isMobile) {
            let openedType = document.querySelector('#list-change-btn [data-view].d-none').getAttribute('data-view');

            if(openedType === 'list') document.querySelector('.fad-list-search-body').classList.remove('d-none');
            else document.getElementById('map-block').classList.remove('d-none');

            let listChangeBtn = document.querySelector('#list-change-btn-wrapper');
            if (listChangeBtn) listChangeBtn.classList.remove('d-none');

        } else {
            document.querySelector('.fad-list-search-body').classList.add('d-md-block');
        }

        filterBtn.setAttribute('data-open', 'false');
    }

    manageFilterPopup(event) {
        if (!event) return;

        this.manageDataLayers('fad-filter-click', event);

        let open = event.target.getAttribute('data-open');

        open = (open && open === 'true');

        if (!open) this.openFilter();
        else this.closeFilter();

        event.target.setAttribute('data-open', !open);

    }

    async buildFilter() {
        let response = null;
        try {
            response = await fetch(`https://alk-app.klarify.me/api/clinics/filters`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${window.klarifyAppToken}`,
                    'Accept': 'application/json'
                },
            });
            response = await response.json();
        } catch (e) {
            console.error('Filter API call failed', e);
            Rollbar.error("Filters API failed");
        }

        let that = this;

        // Sanitize HTML string
        function sanitizeHTMLString(value) {
            return value.trim().replace(/\s+/g, ' ');
        }

        // Build Radius Filter
        function prepareRadiusHTML() {
            let miles = [10, 25, 50, 75, 100];
            let radiusHTML = '';

            miles.forEach(mile => {
                radiusHTML += `
                    <div class="custom-control mb-1 custom-radio pl-0">
                        <input type="radio"
                               value="${mile}"
                               id="mile-${mile}"
                               name="miles"
                               data-value="${mile}"
                               class="custom-control-input"
                               ${that.filters.miles == mile && 'checked'}
                               data-check="${that.filters.miles == mile}"
                        >
                        <label class="custom-control-label pl-4 font-weight-bold cursor-pointer font-poppins-medium" for="mile-${mile}">${mile}</label>
                    </div>
                `;
            });

            return radiusHTML;
        }

        let radiusHTML = `
            <div class="col-md-12 no-cross-radio radius-col px-2 inline-radio">
                <p class="text-uppercase font-weight-bold font-size-sm mb-2 font-poppins-medium">Vzdálenost:</p>
                ${prepareRadiusHTML()}
            </div>
        `;
        radiusHTML = sanitizeHTMLString(radiusHTML);

        // Build Telehealth Filter
        let telehealthHTML = `
            <div class="col-md-12 no-cross-radio offers-telehealth-col px-2 inline-radio-2">
                <p class="text-uppercase font-weight-bold font-size-sm mb-2">Zaměření:</p>
                <div class="custom-control mb-1 custom-radio pl-0">
                    <input
                        type="radio"
                        value="1"
                        id="telehealth_yes"
                        name="telehealth"
                        class="custom-control-input"
                    >
                    <label class="custom-control-label pl-4 font-weight-bold cursor-pointer font-poppins-medium" for="telehealth_yes">Děti a dorast</label>
                </div>

                <div class="custom-control mb-1 custom-radio pl-0">
                    <input
                        type="radio"
                        value="0"
                        id="telehealth_no"
                        name="telehealth"
                        class="custom-control-input"
                        ${that.filters.telehealth == 0 && 'checked'}
                        data-check="${that.filters.telehealth == 0}"
                    >
                    <label class="custom-control-label pl-4 font-weight-bold cursor-pointer font-poppins-medium" for="telehealth_no">Dospělí</label>
                </div>
            </div>
        `;
        telehealthHTML = sanitizeHTMLString(telehealthHTML);

        // Build Specialty Filter
        let majorSpecialtyHTML = '';
        if (response && response.specialist_areas && response.specialist_areas.length) {

            function prepareSpecialityHTML() {
                let majorSpecialtyHTML = '';
                // let ignoreSpecialistFilter = ['Phoniatrie', 'Allgemeinmedizin', 'Innere Medizin', 'Arbeitsmedizin'];

                response.specialist_areas.forEach((specialistArea, index) => {
                    // if(!ignoreSpecialistFilter.includes(specialistArea)) {
                    majorSpecialtyHTML += `
                        <div class="custom-control font-size-sm mb-2 custom-radio pl-0">
                            <input 
                                type="radio" 
                                data-val="${specialistArea}" 
                                value="${specialistArea}"
                                id="${specialistArea.replace(' ', '-')}"
                                name="specialist_areas"
                                class="custom-control-input"
                                ${that.filters.specialist_areas === specialistArea && 'checked'}
                               data-check="${that.filters.specialist_areas === specialistArea}"
                            />
                            <label
                                class="custom-control-label pl-4 font-weight-bold cursor-pointer font-poppins-medium"
                                for="${specialistArea.replace(' ', '-')}"
                            >
                                ${specialistArea}
                            </label>
                        </div>`;
                    // }
                });
                return majorSpecialtyHTML;
            }

            majorSpecialtyHTML = `
                <div class="col-md-12 mb-2 px-2">
                    <p class="text-uppercase font-weight-bold font-size-sm mb-2 font-poppins-medium">Služby:</p>
                    <div class="major_specialty" id="major_specialty">
                        ${prepareSpecialityHTML()}
                    </div>
                </div>
            `;
        }
        majorSpecialtyHTML = sanitizeHTMLString(majorSpecialtyHTML);

        // Build Therapy services Filter
        let therapyServicesHTML = `
            <div class="col-md-12 no-cross-radio offers-telehealth-col px-2 inline-radio-2">
                <p class="text-uppercase font-weight-bold font-size-sm mb-2">Therapie-Leistungen:</p>
                <div class="custom-control font-size-sm mb-2 custom-radio pl-0">
                    <input 
                        type="checkbox"
                        data-val="Allergie-Immuntherapie mit: Tabletten"
                        value="Allergie-Immuntherapie mit: Tabletten"
                        id="is_allergy_diagnostic"
                        name="is_allergy_diagnostic"
                        class="filter-param custom-control-input"
                        ${that.filters.is_allergy_diagnostic == 1 && 'checked'}
                        data-check="${that.filters.is_allergy_diagnostic == 1}"
                    >
                    <label class="custom-control-label pl-4 font-weight-bold cursor-pointer font-poppins-medium" for="is_allergy_diagnostic">Allergie-Immuntherapie mit: Tabletten</label>
                </div>
                <div class="custom-control font-size-sm mb-2 custom-radio pl-0">
                    <input
                        type="checkbox"
                        data-val="Allergie-Immuntherapie mit: Tropfen"
                        value="Allergie-Immuntherapie mit: Tropfen"
                        id="is_subcutaneous_immunotherapy"
                        name="is_subcutaneous_immunotherapy"
                        class="filter-param custom-control-input"
                        ${that.filters.is_subcutaneous_immunotherapy == 1 && 'checked'}
                        data-check="${that.filters.is_subcutaneous_immunotherapy == 1}"
                    >
                    <label class="custom-control-label pl-4 font-weight-bold cursor-pointer font-poppins-medium" for="is_subcutaneous_immunotherapy">Allergie-Immuntherapie mit: Tropfen</label>
                </div>
                <div class="custom-control font-size-sm mb-2 custom-radio pl-0">
                    <input
                        type="checkbox"
                        data-val="Allergie-Immuntherapie mit: Spritzen"
                        value="Allergie-Immuntherapie mit: Spritzen"
                        id="is_sublingual_immunotherapy"
                        name="is_sublingual_immunotherapy"
                        class="filter-param custom-control-input"
                        ${that.filters.is_sublingual_immunotherapy == 1 && 'checked'}
                        data-check="${that.filters.is_sublingual_immunotherapy == 1}"
                    >
                    <label class="custom-control-label pl-4 font-weight-bold cursor-pointer font-poppins-medium" for="is_sublingual_immunotherapy">Allergie-Immuntherapie mit: Spritzen</label>
                </div>
                <div class="custom-control font-size-sm mb-2 custom-radio pl-0">
                    <input
                        type="checkbox"
                        data-val="Insektengift-Immuntherapie"
                        value="Insektengift-Immuntherapie"
                        id="is_insect_allergy_diagnostic"
                        name="is_insect_allergy_diagnostic"
                        class="filter-param custom-control-input"
                        ${that.filters.is_insect_allergy_diagnostic == 1 && 'checked'}
                        data-check="${that.filters.is_insect_allergy_diagnostic == 1}"
                    >
                    <label class="custom-control-label pl-4 font-weight-bold cursor-pointer font-poppins-medium" for="is_insect_allergy_diagnostic">Insektengift-Immuntherapie</label>
                </div>                            
            </div>
        `;
        therapyServicesHTML = sanitizeHTMLString(therapyServicesHTML);

        // Build other services Filter
        var otherServicesHTML = '';
        if (response && response.other_services && response.other_services.length) {
            function prepareOtherServicesHTML() {
                let otherServicesHTML = '';
                response.other_services.forEach((otherService, index) => {
                    otherServicesHTML += `
                    <div class="custom-control font-size-sm mb-2 custom-radio pl-0">
                    <input
                        type="radio"
                        data-val="${otherService}"
                        value="${otherService}"
                        id="${otherService.replace(' ','-')}"
                        name="other_services"
                        class="filter-param custom-control-input"
                        ${that.filters.other_services === otherService && 'checked'}
                        data-check="${that.filters.other_services === otherService}"
                    >
                    <label class="custom-control-label pl-4 font-weight-bold cursor-pointer font-poppins-medium" for="${otherService.replace(' ','-')}">${otherService}</label>
                    </div>`;
                });
                return otherServicesHTML;
            }
            otherServicesHTML = `
                <div class="col-md-12 mb-2 px-2">
                    <p class="text-uppercase font-weight-bold font-size-sm mb-2">Zusatzservices:</p>
                    <div class="major_specialty other_services" id="other_services">
                        ${prepareOtherServicesHTML()}
                    </div>
                </div>
            `;
        }
        otherServicesHTML = sanitizeHTMLString(otherServicesHTML);

        // Build insurance companies Filter
        var insuranceCompaniesHTML = '';
        if (response && response.insurance_companies && response.insurance_companies.length) {
            function prepareinsuranceCompaniesHTML() {
                let insuranceCompaniesHTML = '';
                response.insurance_companies.forEach((insuranceCompany, index) => {
                    insuranceCompaniesHTML += `
                    <div class="custom-control font-size-sm mb-2 custom-radio pl-0">
                        <input
                            type="radio"
                            data-val="${insuranceCompany}"
                            value="${insuranceCompany}"
                            id="${insuranceCompany.replace(' ','-')}"
                            name="insurance_companies"
                            class="filter-param custom-control-input"
                            ${that.filters.insurance_companies === insuranceCompany && 'checked'}
                            data-check="${that.filters.insurance_companies === insuranceCompany}"
                        >
                  <label class="custom-control-label pl-4 font-weight-bold cursor-pointer font-poppins-medium" for="${insuranceCompany.replace(' ','-')}">${insuranceCompany}</label>
                </div>`;
                });
                return insuranceCompaniesHTML;
            }
            insuranceCompaniesHTML = `
                <div class="col-md-12 mb-2 px-2">
                    <p class="text-uppercase font-weight-bold font-size-sm mb-2">Krankenkassen:</p>
                    <div class="major_specialty insurance_companies" id="insurance_companies">
                        ${prepareinsuranceCompaniesHTML()}
                    </div>
                </div>
            `;
        }
        insuranceCompaniesHTML = sanitizeHTMLString(insuranceCompaniesHTML);

        let filterHTML = `<div class="row select_drop mx-n2">
                ${radiusHTML}
                <!-- <hr class="mb-3 w-100">
                ${telehealthHTML} -->
                <hr class="mb-3 w-100">
                ${majorSpecialtyHTML}
                <!-- <hr class="mb-3 w-100">
                ${therapyServicesHTML}
                <hr class="mb-3 w-100">
                ${otherServicesHTML}
                <hr class="mb-3 w-100">
                ${insuranceCompaniesHTML} -->

            </div>
        `;

        let filterContent = document.getElementById('filterContent');
        if (filterContent) {
            filterContent.innerHTML = filterHTML;
        }
    }

    handleRadioFilterClick(event) {
        let name = event.target.getAttribute('name');
        if (!name) return;

        let previousCheck = event.target.getAttribute('data-check');
        previousCheck = previousCheck && previousCheck === 'true';

        document.querySelectorAll(`#filterContent input[name=${name}]`).forEach(element => {
            element.setAttribute('data-check', 'false');
        });

        if (previousCheck) {
            event.target.setAttribute('data-check', 'false');
            event.target.checked = false;
        } else {
            event.target.setAttribute('data-check', 'true');
        }
    }

    async resetFilters() {
        document.querySelectorAll('#filterContent input[type="radio"]').forEach(element => {
            element.checked = false;
            element.setAttribute('data-check', 'false');
        });

        for (const [name, value] of Object.entries(this.filters)) {

            if (this.filters[name]) this.filtersApplied = true;
            this.filters[name] = null;
        }

        this.closeFilter();

        await this.updateRecords();
        this.filtersApplied = false;
    }

    async manageApplyFilters() {

        // this.manageDataLayers('fad-filter-apply');

        for (const [name, value] of Object.entries(this.filters)) {
            this.filters[name] = '';
        }

        document.querySelectorAll('#filterContent input[type="radio"]').forEach((element) => {

            let name = element.getAttribute('name');
            let value = element.value;
            let isChecked = element.checked;

            if (name === 'only_private_patient' && isChecked) this.filters.only_private_patient = 1;

            if (name === 'is_doctor' && isChecked) this.filters.is_doctor = parseInt(value);

            if (name === 'is_allergy_diagnostic' && isChecked) this.filters.is_allergy_diagnostic = 1;
            if (name === 'is_insect_allergy_diagnostics' && isChecked) this.filters.is_insect_allergy_diagnostics = 1;
            if (name === 'is_sublingual_subcutaneous_immunotherapy' && isChecked) {

                this.filters.is_sublingual_immunotherapy = 1;
                this.filters.is_subcutaneous_immunotherapy = 1;
            }
            if (name === 'is_venom_immunotherapy' && isChecked) this.filters.is_venom_immunotherapy = 1;
            if (name === 'clinic_types' && isChecked) this.filters.clinic_types = value;

            if (name === 'specialist_areas' && isChecked) this.filters.specialist_areas = value;
            if (name === 'other_services' && isChecked) this.filters.other_services = value;
            if (name === 'insurance_companies' && isChecked) this.filters.insurance_companies = value;
            if (name === 'miles' && isChecked) {
                this.filters.miles = value;
                this.filters.radius = value * 1609.34;
            }
            if (name === 'telehealth' && isChecked) this.filters.telehealth = value;

        });

        let filtersNameArray = [];
        for(const [name, value] of Object.entries(this.filters)) {
            if(value != '' && name != 'miles'){
                filtersNameArray.push(name);
            }
        }       
        let filtersName = filtersNameArray.join(',');        
        this.manageDataLayers('fad-filter-apply', null, filtersName);

        this.closeFilter();

        this.filtersApplied = true;
        await this.updateRecords();
        this.filtersApplied = false;
    }

    bindEvents() {

        document.querySelector('#fad-search').addEventListener('click', (event) => {
                this.handleSearchInputClick(event);
        });

        if(!this.fadWidget) {
            document.querySelectorAll('#list-change-btn [data-view]').forEach((element) => {
                element.addEventListener('click', (event) => {
                    this.manageSwitchView(event);
                });
            });

            document.getElementById('fad-filters-btn').addEventListener('click', (event) => {
                this.manageFilterPopup(event);
            });

            document.getElementById('filter_close').addEventListener('click', () => {
                this.closeFilter();
                // this.manageDataLayers('fad-filter-click', event, 'close');
            });

            document.getElementById('fad-filters-reset-btn').addEventListener('click', () => this.resetFilters());

            document.getElementById('fad-filters-apply-btn').addEventListener('click', async () => this.manageApplyFilters());

            document.querySelectorAll('#filterContent input[type="radio"]').forEach(element => {
                element.addEventListener('click', (event) => this.handleRadioFilterClick(event));
            });
        }
        else {
            let fadSearchButton = document.querySelector('#fad-widget button.search__button');
            if(fadSearchButton) {
                document.querySelector('#fad-widget button.search__button').addEventListener('click', async () => {
                    await this.fadWidgetSearchBtnClick();
                });
            }
        }

    }

    bindCardDetailEvents(markerPopup = null) {
        let parentElement = markerPopup ? markerPopup : document;
        parentElement.querySelectorAll('.doc-phone').forEach(element => {
            element.addEventListener('click', (event) => {
                event.stopPropagation();
                let {clinic, clinicEl} = this.getCurrentClinicFromHtml(event);
                if (clinicEl && !clinicEl.classList.contains('active')) clinicEl.click();

                this.manageDataLayers('fad-phone-click', event, clinic);
            });
        });

        parentElement.querySelectorAll('.doc-email').forEach(element => {
            element.addEventListener('click', (event) => {
                event.stopPropagation();
                let {clinic, clinicEl} = this.getCurrentClinicFromHtml(event);
                if (clinicEl && !clinicEl.classList.contains('active')) clinicEl.click();

                this.manageDataLayers('fad-email-click', event, clinic);
            });
        });

        parentElement.querySelectorAll('.direction-btn').forEach(element => {
            element.addEventListener('click', (event) => {
                event.stopPropagation();
                let {clinic, clinicEl} = this.getCurrentClinicFromHtml(event);
                if (clinicEl && !clinicEl.classList.contains('active')) clinicEl.click();

                this.manageDataLayers('fad-direction-click', event, clinic);
            });
        });

        parentElement.querySelectorAll('.website-click').forEach(element => {
            element.addEventListener('click', (event) => {
                event.stopPropagation();
                let {clinic, clinicEl} = this.getCurrentClinicFromHtml(event);
                if (clinicEl && !clinicEl.classList.contains('active')) clinicEl.click();

                this.manageDataLayers('fad-website-click', event, clinic);
            });
        });

        parentElement.querySelectorAll('.online-appointment-click').forEach(element => {
            element.addEventListener('click', (event) => {
                event.stopPropagation();
                let {clinic, clinicEl} = this.getCurrentClinicFromHtml(event);
                if (clinicEl && !clinicEl.classList.contains('active')) clinicEl.click();

                this.manageDataLayers('fad-online-appointment-click', event, clinic);
            });
        });

        parentElement.querySelectorAll('.doctor-detail-click').forEach(element => {
            element.addEventListener('click', (event) => {
                event.stopPropagation();
                let {clinic, clinicEl} = this.getCurrentClinicFromHtml(event);
                if (clinicEl && !clinicEl.classList.contains('active')) clinicEl.click();

                if (clinicEl) clinicEl.classList.toggle('details-open');

                document.getElementById(`panel-${clinic.id}`).classList.toggle('d-none');

                this.manageDataLayers('fad-detail-click', event, clinic);
            });
        });

        parentElement.querySelectorAll('.doctor-popup-detail-click').forEach(element => {
            element.addEventListener('click', (event) => {
                event.stopPropagation();
                let {clinic, clinicEl} = this.getCurrentClinicFromHtml(event);
                if (clinicEl && !clinicEl.classList.contains('active')) clinicEl.click();

                this.manageDataLayers('fad-detail-click', event, clinic);
            });
        });

        if (!markerPopup) {
            document.querySelectorAll('.search-data-block').forEach((clinicEl, clinicElIndex) => {

                let doctorID = parseInt(clinicEl.getAttribute('data-id'));

                clinicEl.addEventListener('click', (event) => this.handleCardClick(event, doctorID, clinicEl, clinicElIndex));
            });
        }
    }

    getCurrentClinicFromHtml(event) {
        let clinicEl = event.target.closest('[data-id]');
        let clinic = this.clinic;
        if (clinicEl) {
            let clinicId = clinicEl.getAttribute('data-id');
            let tempClinic = this.clinics.find(item => item.id == clinicId);
            if (tempClinic) clinic = tempClinic;
        }

        return {
            clinic, clinicEl
        };
    }

    manageDataLayers(handle, event = null, data = null) {

        console.log(handle, data);

        try {
            switch (handle) {
                case 'fad-card-viewed':
                    if (!data) return;
                    window.dataLayer.push({
                        event: "FAD_DoctorListViewed",
                        latest_location:  `${data.street}, ${this.capitalize(data.city)}, ${data.state ? data.state.toUpperCase() : ''} ${data.zipcode}`
                    });
                    break;
                case 'fad-switch-view':
                    window.dataLayer.push({
                        event: "FAD_SwitchView",
                        view: data
                    });
                    break;
                case 'fad-phone-click':
                    if (!data) return;
                    window.dataLayer.push({
                        event: "FAD_PhoneClick",
                        doctorInfo: {
                            doctorName: data.doctor_name,
                            doctorCity: data.city,
                            latest_location: this.searchValue,
                        }
                    });
                    break;
                case 'fad-email-click':
                    if (!data) return;
                    window.dataLayer.push({
                        event: "FAD_MailClick",
                        doctorInfo: {
                            doctorName: data.doctor_name,
                            doctorCity: data.city,
                            doctorMail: data.email,
                        }
                    });
                    break;
                case 'fad-search-location':
                    window.dataLayer.push({
                        event: "FAD_Search",
                        search_text: data,
                        latest_location: data
                    });
                    break;
                case 'fad-direction-click':
                    if (!data) return;
                    window.dataLayer.push({
                        event: "FAD_DirectionsClick",
                        doctorInfo: {
                            doctorName: data.doctor_name,
                            doctorCity: data.city
                        }
                    });
                    break;
                case 'fad-online-appointment-click':
                    if (!data) return;
                    window.dataLayer.push({
                        event: "FAD_BookClick",
                        doctorInfo: {
                            doctorName: data.doctor_name,
                            doctorCity: data.city,
                            latest_location: this.searchValue
                        }
                    });
                    break;
                case 'fad-website-click':
                    if (!data) return;
                    window.dataLayer.push({
                        event: "FAD_WebsiteClick",
                        doctorInfo: {
                            doctorName: data.doctor_name,
                            doctorCity: data.city,
                            latest_location: this.searchValue,
                        }
                    });
                    break;
                case 'fad-filter-apply':
                    window.dataLayer.push({
                        event: "FAD_FilterApplied"
                    });
                    break;
                case 'fad-detail-click':
                    window.dataLayer.push({
                        event: "FAD_DoctorDetailClick",
                        doctorInfo: {
                            doctorName: data.doctor_name,
                            doctorCity: data.city,
                            latest_location: this.searchValue,
                        }
                    });
                    break;
                case 'fad-pin-click':
                    if (!data) return;
                    window.dataLayer.push({
                        event: "FAD_PinClick",
                        doctorInfo: {
                            doctorName: data.doctor_name,
                            doctorCity: data.city,
                            latest_location: this.searchValue,
                        }
                    });
                    break;
                case 'fad-filter-click':
                    window.dataLayer.push({
                        event: "FAD_FilterClick"
                    });
                    break;
                case 'fad-map-interaction':
                    window.dataLayer.push({
                        'event': 'FAD_MapInteraction',
                        'interaction_type': data
                    });
                    break;
            }

        } catch (e) {
            console.error(e);
            Rollbar.error("Datalayer on FAD failed");
        }
    }

    manageURL(params, custom = false) {

        const url = new URL(window.location.href);
        let queryParams = url.searchParams;

        if (!custom) {
            for (const [name, value] of Object.entries(this.filters)) queryParams.delete(name);
        }

        for (const [name, value] of Object.entries(params)) queryParams.set(name, value);

        if (!custom) {

            if (this.searchValue) queryParams.set('address', this.searchValue);

            let zoom = parseFloat(this.map.getZoom().toFixed(2));
            if (zoom > 0) queryParams.set('zoom', zoom);

            queryParams.delete('radius');
            queryParams.delete('country');
        }

        if(!this.fadWidget) window.history.pushState({ path: url.href }, '', url.href);
    }

    capitalize(value) {
        if (!value) return '';
        value = value.toLowerCase();
        let words = value.split(' ');
        for (let i = 0; i < words.length; i++) {
            let word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
        }
        return words.join(' ').trim();
    }

    formatCoordinates(latitude, longitude) {
        return {
            latitude: parseFloat(parseFloat(latitude).toFixed(6).toString()),
            longitude: parseFloat(parseFloat(longitude).toFixed(6).toString())
        };
    }

    getDistance() {
        // Get the pixel coordinates of the marker
        const point1 = turf.point([this.referenceCoordinates.longitude, this.referenceCoordinates.latitude]);
        const point2 = turf.point([this.apiParams.lng, this.apiParams.lat]);

        return turf.distance(point1, point2, { units: 'meters' });
    }

    calculateDistance(lat1, lon1, lat2, lon2) {
        let earthRadius = 6371; // Radius of the Earth in kilometers
        let dLat = (lat2 - lat1) * (Math.PI / 180);
        let dLon = (lon2 - lon1) * (Math.PI / 180);
        let a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * (Math.PI / 180)) *
            Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
        return earthRadius * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
    }

    getMapRadius(north, east, south, west) {

        let northSouth = north - south;
        let eastWest = east - west;

        if (eastWest < northSouth) north = south = 0;
        else east = west = 0;

        const point1 = turf.point([north, east]);
        const point2 = turf.point([south, west]);

        let radius = turf.distance(point1, point2, { units: 'meters' });

        return (radius > window.defaultSearchRadius) ? window.defaultSearchRadius : radius;
    }

    setCookie(name, value, minutes) {
        window.dataLayer.forEach((elem) => {
            if (elem.event === "cookie_cat_marketing" || elem.action === "onAcceptAllServices") {
                let date = new Date();
                date.setTime(date.getTime() + (minutes * 60 * 1000));
                let c_value = escape(value) + ((minutes == null) ? "" : "; expires=" + date.toUTCString() + "; path=/");
                document.cookie = name + "=" + c_value;

                return document.cookie;
            }
        });
        localStorage.setItem(name, value);
    }

    getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                return unescape(cookie.substring(name.length + 1));
            }
        }
        return null; // Cookie not found
    }

    elementsOverlap(el1, el2) {

        if (!el1 || !el2) return false;

        const domRect1 = el1.getBoundingClientRect();
        const domRect2 = el2.getBoundingClientRect();

        return !(
            domRect1.top > domRect2.bottom ||
            domRect1.right < domRect2.left ||
            domRect1.bottom < domRect2.top ||
            domRect1.left > domRect2.right
        );
    }

    isElementIntoView(element) {
        if (!element) return;
        const rect = element.getBoundingClientRect();
        return (
          rect.bottom > 0 &&
          rect.right > 0 &&
          rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
          rect.top < (window.innerHeight || document.documentElement.clientHeight)
        );
    };

    isElementCovered(outerElement, innerElement) {

        if (!outerElement || !innerElement) return;

        const outerRect = outerElement.getBoundingClientRect();
        const innerRect = innerElement.getBoundingClientRect();

        return (
            innerRect.top >= outerRect.top &&
            innerRect.left >= outerRect.left &&
            innerRect.right <= outerRect.right &&
            innerRect.bottom <= outerRect.bottom
        );
    }

    isElementsIntersecting(element1, element2) {

        if (!element1 || !element2) return;

        const rect1 = element1.getBoundingClientRect();
        const rect2 = element2.getBoundingClientRect();

        return (
            rect1.left <= rect2.right &&
            rect1.right >= rect2.left &&
            rect1.top <= rect2.bottom &&
            rect1.bottom >= rect2.top
        );
    }

    validateCoordinates(latitude, longitude) {
        return !(isNaN(latitude) ||
            isNaN(longitude) ||
            latitude < -90 ||
            latitude > 90 ||
            longitude < -180 ||
            longitude > 180
        );
    }

    async fitMapBounds(bbox, latLong) {
        if (bbox && bbox.length) await this.map.fitBounds(bbox);
        else {
            await this.map.fitBounds(new mapboxgl.LngLatBounds(
                [latLong.lng - 0.01, latLong.lat - 0.01],
                [latLong.lng + 0.01, latLong.lat + 0.01]
            ), {
                padding: {
                    top: 50, bottom: 50, left: 50, right: 50
                }
            });
        }
    }
}

new Fad();
